import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'
import { type RetailerContextType } from '@/features/shared/context/RetailerContext'

export const useViewContext = (retailerContext: RetailerContextType | undefined) => {
  useEffect(() => {
    const value = {
      shoppingContext: retailerContext ? 'retailer' : 'global',
      retailerId: retailerContext?.storeParams.store_id,
      retailerName: retailerContext?.storeName,
    }
    datadogRum.setViewContextProperty('shopping', value)
  }, [retailerContext])
}
